import {
    actionTypes as asyncTypes,
    isAsyncOperation,
    isAsyncComplete,
  } from "async-ops";
import { GET_DELETED_EXTERNAL_AUDIT_LIST } from "../services/get-deleted-external-audit-list";

const initialState = {
    isLoading: false,
    deletedExternalAuditList: []
}

export default function(state = initialState, action) {
    switch (action.type) {
        case asyncTypes.OPERATION:
        case asyncTypes.COMPLETE:
        case asyncTypes.FAILURE:
              if (isAsyncOperation(GET_DELETED_EXTERNAL_AUDIT_LIST)(action)) {
                return { ...state, deletedExternalAuditList: [] };
              }
              if (isAsyncComplete(GET_DELETED_EXTERNAL_AUDIT_LIST)(action)) {
                const response = action.response;
                return { ...state, deletedExternalAuditList: response };
              }
              return state;
              default:
                return state;
    }
}